import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { Badge } from "@rentablo/components";

const MAX_VISIBLE_PERMISSIONS = 2;

type Props = {
  permissions: string[];
};

export const PermissionBadges = ({ permissions }: Props) => {
  const visible = permissions.slice(0, MAX_VISIBLE_PERMISSIONS);
  const hidden = permissions.slice(MAX_VISIBLE_PERMISSIONS);
  const hiddenTooltip = hidden.join(", ");

  return (
    <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
      {visible.map((permission) => (
        <Badge key={permission} variant="primary">
          <Typography variant="caption" noWrap>
            {permission}
          </Typography>
        </Badge>
      ))}
      {hidden.length > 0 && (
        <Tooltip title={hiddenTooltip}>
          <Typography variant="caption" color="textSecondary">
            +{hidden.length}
          </Typography>
        </Tooltip>
      )}
    </Box>
  );
};
